import { useUser } from '../components/Context/UserContext';
import { mergePermissions } from '../constants/modulesConfig';

const BYPASS_ROLES = ['Socio', 'Gestor', 'Root'];

export const usePermissions = () => {
  const { user } = useUser();

  const bypass = !user || BYPASS_ROLES.includes(user.role);
  const permissions = bypass ? null : mergePermissions(user.permissions);

  const can = (moduleKey, itemKey, action = 'visualizar') => {
    if (bypass) return true;
    return !!permissions?.[moduleKey]?.[itemKey]?.[action];
  };

  const canModule = (moduleKey) => {
    if (bypass) return true;
    return !!permissions?.[moduleKey]?.status;
  };

  return { can, canModule };
};
